<template>
  <div class="items">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.items {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0.8rem 0;
}
</style>
